/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Batch_Subtitle_Export_Event_Groups_AriaInputs */

const en_batch_subtitle_export_event_groups_aria = /** @type {(inputs: Batch_Subtitle_Export_Event_Groups_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select event groups for export`)
};

const fr_batch_subtitle_export_event_groups_aria = /** @type {(inputs: Batch_Subtitle_Export_Event_Groups_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionner les groupes d’événements pour l’export`)
};

const de_batch_subtitle_export_event_groups_aria = /** @type {(inputs: Batch_Subtitle_Export_Event_Groups_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignisgruppen für den Export auswählen`)
};

const it_batch_subtitle_export_event_groups_aria = /** @type {(inputs: Batch_Subtitle_Export_Event_Groups_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona gruppi di eventi per l'esportazione`)
};

const ru_batch_subtitle_export_event_groups_aria = /** @type {(inputs: Batch_Subtitle_Export_Event_Groups_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите группы событий для экспорта`)
};

const es_batch_subtitle_export_event_groups_aria = /** @type {(inputs: Batch_Subtitle_Export_Event_Groups_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar grupos de eventos para exportar`)
};

const zh_cn2_batch_subtitle_export_event_groups_aria = /** @type {(inputs: Batch_Subtitle_Export_Event_Groups_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择要导出的事件组`)
};

const ja_batch_subtitle_export_event_groups_aria = /** @type {(inputs: Batch_Subtitle_Export_Event_Groups_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エクスポートするイベントグループを選択`)
};

const hi_batch_subtitle_export_event_groups_aria = /** @type {(inputs: Batch_Subtitle_Export_Event_Groups_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्यात के लिए इवेंट समूह चुनें`)
};

const pt_pt2_batch_subtitle_export_event_groups_aria = /** @type {(inputs: Batch_Subtitle_Export_Event_Groups_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione os grupos de eventos para exportação.`)
};

/**
* | output |
* | --- |
* | "Select event groups for export" |
*
* @param {Batch_Subtitle_Export_Event_Groups_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const batch_subtitle_export_event_groups_aria = /** @type {((inputs?: Batch_Subtitle_Export_Event_Groups_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Batch_Subtitle_Export_Event_Groups_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_batch_subtitle_export_event_groups_aria(inputs)
	if (locale === "de") return de_batch_subtitle_export_event_groups_aria(inputs)
	if (locale === "it") return it_batch_subtitle_export_event_groups_aria(inputs)
	if (locale === "ru") return ru_batch_subtitle_export_event_groups_aria(inputs)
	if (locale === "es") return es_batch_subtitle_export_event_groups_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_batch_subtitle_export_event_groups_aria(inputs)
	if (locale === "ja") return ja_batch_subtitle_export_event_groups_aria(inputs)
	if (locale === "hi") return hi_batch_subtitle_export_event_groups_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_batch_subtitle_export_event_groups_aria(inputs)
	return en_batch_subtitle_export_event_groups_aria(inputs)
});